import React from "react";
import "./TopBar.css";

function TopBar() {
  const items = [
    { text: "ALL COLLECTIONS" },
    // { text: "FREE SHIPPING ON ALL ORDERS ABOVE ₹999!" },
    { text: "మన వస్త్రాలు · మన గుర్తింపు", telugu: true },
    // { text: "NEW ETHNIC ARRIVALS EVERY WEEK!" },
    { text: "ఆడావారి ఆనందానికి సరైన చిరునామా", telugu: true },
  ];

  const doubled = [...items, ...items]; // seamless loop

  return (
    <div className="topbar">
      <div className="topbar-inner">
        <span className="topbar-floral">❀</span>
        <div className="marquee-track">
          <div className="marquee-content">
            {doubled.map((item, i) => (
              <React.Fragment key={i}>
                <span className={`marquee-item${item.telugu ? " telugu" : ""}`}>
                  {item.text}
                </span>
                <span className="marquee-dot" />
              </React.Fragment>
            ))}
          </div>
        </div>
        <span className="topbar-floral">❀</span>
      </div>
    </div>
  );
}

export default TopBar;